import React from "react";
import { withRouter } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import {
	FormGroup,
	FormControl,
	FormLabel,
} from "react-bootstrap";
import { DateRangePicker } from "react-dates";
import SubmitButton from "components/SubmitButton";
import InlineAlert from "components/InlineAlert";
import * as groupsActions from "actions/groupsActions";
import {
	RELATIVE_DATE_PRESETS,
	computeRelativeDateRange,
	DATE_PRESET_CUSTOM,
} from "utils/relativeDatePresets";

class PlanOpener extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);

		const DATE_PRESET_STORAGE_KEY = "planning_datePreset";
		const storedPreset =
			localStorage.getItem(DATE_PRESET_STORAGE_KEY) || DATE_PRESET_CUSTOM;

		const applyPresetToDates = (presetId) => {
			if (!presetId || presetId === DATE_PRESET_CUSTOM) return null;
			const range = computeRelativeDateRange(presetId, moment());
			if (!range?.start || !range?.end) return null;
			return {
				start: range.start.format("YYYY-MM-DD"),
				end: range.end.format("YYYY-MM-DD"),
			};
		};

		const presetDates = applyPresetToDates(storedPreset);

		this.state = {
			datePreset: storedPreset,
			start: presetDates ? presetDates.start : this.props.start || "",
			end: presetDates ? presetDates.end : this.props.end || "",
			group_id: this.props.group_id || "",
			isLoading: false,
			submitted: false,
			error: "",
			focusedInput: null,
		};
	}

	componentDidMount() {
		this.props.getAllGroups();
	}

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate)
			startDate = startDate.format("YYYY-MM-DD");

		if (endDate)
			endDate = endDate.format("YYYY-MM-DD");

		this.setState({
			start: startDate,
			end: endDate,
			datePreset: DATE_PRESET_CUSTOM,
		});

		localStorage.setItem("planning_datePreset", DATE_PRESET_CUSTOM);
	};


	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	handleDatePresetClick = (presetId) => {
		const nextPreset = presetId || DATE_PRESET_CUSTOM;
		localStorage.setItem("planning_datePreset", nextPreset);

		// Cerrar el popup del picker al seleccionar cualquier opción.
		if (nextPreset === DATE_PRESET_CUSTOM) {
			// “Personalizada” no altera fechas
			this.setState({ datePreset: nextPreset, focusedInput: null });
			return;
		}

		const range = computeRelativeDateRange(nextPreset, moment());
		if (!range?.start || !range?.end) {
			this.setState({ datePreset: nextPreset, focusedInput: null });
			return;
		}

		this.setState({
			datePreset: nextPreset,
			start: range.start.format("YYYY-MM-DD"),
			end: range.end.format("YYYY-MM-DD"),
			focusedInput: null,
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	checkInvalidRange = () => {
		return (
			this.state.submitted &&
			(this.state.start === "" ||
				this.state.end === "" ||
				this.state.start === null ||
				this.state.end === null ||
				this.state.error !== "")
		);
	};

	// open plan
	handleSubmit = async (event) => {
		event.preventDefault();
		const { group_id, start, end, error } = this.state;
		const props = this.props;

		if (group_id && start && end && error === "") {
			const newURL = `/plans/${group_id}/${start}@${end}`;
			window.history.pushState(null, "", newURL);
			props.updateStateAndReload({ group_id, start, end });
			props.handleClose();
		}

		this.setState({
			submitted: true,
			error,
		});
	};

	render() {
		const { t } = this.props;
		const { error, start, end, group_id, submitted } = this.state;
		const { detailed_groups } = this.props;

		const optionGroupList =
			detailed_groups.length > 0 &&
			detailed_groups.map((item, i) => {
				let multigroup = item.is_multigroup ? ` (${t('planOpener.multigroup')})` : "";
				return (
					<option key={i} value={item.id}>
						{item.name}
						{multigroup}
					</option>
				);
			}, this);
		return (
			<form onSubmit={this.handleSubmit}>
				<div className="modal-body plan-opener-modal">

					<FormGroup className="form-group" controlId="group_id">
						<FormLabel>{t('planOpener.group')}</FormLabel>
						<FormControl
							value={group_id}
							onChange={this.handleChange}
							isInvalid={submitted && group_id === ""}
							as="select"
						>
							<option value="">{t('planOpener.selectGroup')}</option>
							{optionGroupList}
						</FormControl>
						<FormControl.Feedback type="invalid">
							{t('planOpener.selectGroupError')}
						</FormControl.Feedback>
					</FormGroup>

					<FormGroup
						className={`form-group form-group-periodo ${this.checkInvalidRange() ? "is-invalid" : ""
							}`}
					>
						<FormLabel>{t('planOpener.period')}</FormLabel>
						<DateRangePicker
							startDateId="startDateId"
							endDateId="endDateId"
							startDate={start ? moment(start) : null}
							endDate={end ? moment(end) : null}
							startDatePlaceholderText={t('common.periodStart')}
							endDatePlaceholderText={t('common.periodEnd')}
							onDatesChange={this.onDatesChange}
							focusedInput={this.state.focusedInput}
							hideKeyboardShortcutsPanel={true}
							isOutsideRange={() => false}
							minimumNights={0}
							calendarInfoPosition="before"
							renderCalendarInfo={() => (
								<div
									style={{
										padding: "6px 10px",
										width: 180,
										display: "flex",
										flexDirection: "column",
										gap: 6,
										alignItems: "stretch",
										overflowY: "auto",
									}}
								>
									{RELATIVE_DATE_PRESETS.map((preset) => {
										const isSelected = this.state.datePreset === preset.id;
										return (
											<button
												type="button"
												key={preset.id}
												onClick={() => this.handleDatePresetClick(preset.id)}
												style={{
													width: "100%",
													textAlign: "left",
													background: isSelected ? "#5b5dff" : "transparent",
													color: isSelected ? "#fff" : "#6b7280",
													border: "none",
													padding: "8px 10px",
													borderRadius: 6,
													cursor: "pointer",
													fontWeight: isSelected ? 700 : 600,
												}}
											>
												{this.props.t(preset.label)}
											</button>
										);
									})}
								</div>
							)}
							onFocusChange={(focusedInput) =>
								this.setState({ focusedInput })
							}
						/>
						<FormControl
							className="hidden"
							isInvalid={this.checkInvalidRange()}
						/>

						<FormControl.Feedback type="invalid">
							{error !== "" ? error : t('planOpener.dateRangeError')}
						</FormControl.Feedback>
					</FormGroup>

					{this.state.error_footer && (
						<InlineAlert variant="error" className="mt15">
							{this.state.error_footer}
						</InlineAlert>
					)}

					{/* {this.state.errors && this.state.errors.plan_id && (
						<div
							className="alert alert-danger alert-general-error fade show"
							role="alert"
						>
							{this.state.errors.plan_id}
						</div>
					)} */}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t('common.cancel')}
					</button>
					<SubmitButton
						type="submit"
						isLoading={this.state.isLoading}
						text={t('planOpener.openPlan')}
						loadingText={t('planOpener.opening')}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		loading: reducers.groupsReducer.loading,
		user: reducers.authReducer.user,
	};
};


const mapDispatchToProps = (dispatch) => ({
	getAllGroups: () =>
		dispatch(
			groupsActions.getAllGroups({ sort: "+name", variant: "detailed" })
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTranslation()(PlanOpener)));

